var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 23.2V8.79999C30.4 7.47199 29.328 6.39999 28 6.39999H5.58402C4.25602 6.39999 3.18402 7.47199 3.18402 8.79999V23.2C3.18402 24.528 4.25602 25.6 5.58402 25.6H28C29.328 25.6 30.4 24.528 30.4 23.2ZM28.304 8.62399C28.832 9.15199 28.544 9.69599 28.256 9.96799L21.76 15.92L28 22.416C28.192 22.64 28.32 22.992 28.096 23.232C27.888 23.488 27.408 23.472 27.2 23.312L20.208 17.344L16.784 20.464L13.376 17.344L6.38402 23.312C6.17602 23.472 5.69602 23.488 5.48802 23.232C5.26402 22.992 5.39202 22.64 5.58402 22.416L11.824 15.92L5.32802 9.96799C5.04002 9.69599 4.75202 9.15199 5.28002 8.62399C5.80802 8.09599 6.35202 8.35199 6.80002 8.73599L16.784 16.8L26.784 8.73599C27.232 8.35199 27.776 8.09599 28.304 8.62399V8.62399Z",
    fill: "#3E4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomMail);
export default __webpack_public_path__ + "static/media/custom_mail.5d3e227702f9bb9d9f105736a1c619c8.svg";
export { ForwardRef as ReactComponent };